var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticStyle: { width: "fit-content" } },
            [
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "basicForm",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      },
                      attrs: {
                        inline: true,
                        "label-position": "left",
                        "label-width": "90px"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "4", disabled: _vm.readonly },
                              on: {
                                change: function($event) {
                                  return _vm.isMblOnlyChange()
                                }
                              },
                              model: {
                                value: _vm.job.mblOnly,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mblOnly", $$v)
                                },
                                expression: "job.mblOnly"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DirectBusiness")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "5", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.trans,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "trans", $$v)
                                },
                                expression: "job.trans"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaImport.ChangeOrders")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "6", disabled: _vm.readonly },
                              on: { change: _vm.chkWarehousing_changeHandler },
                              model: {
                                value: _vm.job.warehousing,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "warehousing", $$v)
                                },
                                expression: "job.warehousing"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Storage")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "7", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.parts,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "parts", $$v)
                                },
                                expression: "job.parts"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Devanning")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "8", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.landTransportation,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "landTransportation", $$v)
                                },
                                expression: "job.landTransportation"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DeliveryToDoor")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "9", disabled: _vm.readonly },
                              on: { change: _vm.chkCustoms_changeHandler },
                              model: {
                                value: _vm.job.customs,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customs", $$v)
                                },
                                expression: "job.customs"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CustomsDeclaration"))
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { disabled: _vm.readonly },
                              model: {
                                value: _vm.job.insure,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "insure", $$v)
                                },
                                expression: "job.insure"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.InsureInfo")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "10", disabled: _vm.readonly },
                              on: { change: _vm.isMBLChange },
                              model: {
                                value: _vm.job.signMBL,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "signMBL", $$v)
                                },
                                expression: "job.signMBL"
                              }
                            },
                            [_vm._v("MB/L")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: {
                                no: "11",
                                disabled:
                                  _vm.readonly ||
                                  (!_vm.readonly && _vm.job.mblOnly)
                              },
                              on: { change: _vm.isHBLChange },
                              model: {
                                value: _vm.job.signHBL,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "signHBL", $$v)
                                },
                                expression: "job.signHBL"
                              }
                            },
                            [_vm._v("HB/L")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "12", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.booking,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "booking", $$v)
                                },
                                expression: "job.booking"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "13", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.itmService,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "itmService", $$v)
                                },
                                expression: "job.itmService"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "14", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.international,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "international", $$v)
                                },
                                expression: "job.international"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.InternationalTransport")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox",
                              attrs: { no: "15", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.usCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "usCustomsClearance", $$v)
                                },
                                expression: "job.usCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.UsCustomsClearance"))
                              )
                            ]
                          ),
                          !_vm.job.lclMasterUuid
                            ? _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "15.5", disabled: _vm.readonly },
                                  model: {
                                    value: _vm.job.importManifest,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "importManifest", $$v)
                                    },
                                    expression: "job.importManifest"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaImport.ImportManifest"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: ["button_insurance_toInsure"],
                                  expression: "['button_insurance_toInsure']"
                                }
                              ],
                              staticStyle: { "margin-left": "10px" },
                              attrs: {
                                no: "16",
                                disabled: _vm.isEdit || !!_vm.previewConfig,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.toInsure()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                          ),
                          !!_vm.templateName
                            ? _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  staticStyle: {
                                    float: "right",
                                    "margin-right": "30px",
                                    "line-height": "28px",
                                    padding: "0 5px",
                                    "white-space": "nowrap"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_SopTemplate")
                                    ) +
                                      ": " +
                                      _vm._s(_vm.templateName)
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "basic-tab-UICustom-layout",
                { attrs: { "element-blocks": _vm.elementBlocks } },
                [
                  _vm.elementDict.jobNo.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "jobNo" }, slot: "jobNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.jobNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.jobNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "1", disabled: true },
                            model: {
                              value: _vm.job.jobNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "jobNo", $$v)
                              },
                              expression: "job.jobNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.masterJobNo.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "masterJobNo" }, slot: "masterJobNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.masterJobNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.masterJobNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "2", disabled: true },
                            model: {
                              value: _vm.job.masterJobNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "masterJobNo", $$v)
                              },
                              expression: "job.masterJobNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customerRefNo.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customerRefNo" },
                          slot: "customerRefNo"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customerRefNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customerRefNo.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "3",
                              disabled: _vm.readonly,
                              "auto-uppercase": _vm.isUppercase,
                              trim: true
                            },
                            model: {
                              value: _vm.job.customerRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customerRefNo", $$v)
                              },
                              expression: "job.customerRefNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customerId.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "customerId" }, slot: "customerId" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customerId.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customerId.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.sopImageA,
                                      expression: "sopImageA"
                                    }
                                  ],
                                  attrs: {
                                    no: "17",
                                    content: _vm.$t("SeaExport.SOPReceiver"),
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticStyle: {
                                        padding: "5px 0",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        src: _vm.sopPic,
                                        width: "18",
                                        height: "28"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.sopChangeCustomerIdHandler()
                                        }
                                      }
                                    })
                                  ])
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.creditTip.showWarningImageA,
                                      expression: "creditTip.showWarningImageA"
                                    }
                                  ],
                                  attrs: {
                                    content: _vm.creditTip.warningImageATip,
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning red",
                                    staticStyle: { cursor: "pointer" }
                                  })
                                ]
                              ),
                              _c("cargo-sales-company-select", {
                                staticClass: "shipper-selector",
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "18",
                                  "popper-class": "shipper-selector-popper",
                                  "method-params": {
                                    customer: true,
                                    active: true,
                                    companyLob: "seaImport"
                                  },
                                  "check-credit": true,
                                  "default-value": _vm.job.customerId || "",
                                  disabled: !_vm.customerEnabled,
                                  job: _vm.job
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.customerIdEnterHandler(p)
                                    _vm.pm.clearPoNo()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customerRemarks.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customerRemarks" },
                          slot: "customerRemarks"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customerRemarks.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customerRemarks.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "19",
                                disabled: _vm.readonly,
                                clearable: true,
                                "allow-create": true,
                                filterable: ""
                              },
                              on: { blur: _vm.selectCustomerRemarksBlur },
                              model: {
                                value: _vm.job.customerRemarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customerRemarks", $$v)
                                },
                                expression: "job.customerRemarks"
                              }
                            },
                            _vm._l(_vm.customerRemarks, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.lable, value: item.lable }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isZY
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: { slot: "saleProductCode" },
                            slot: "saleProductCode"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AllowSaleProduct,
                                filterable: "",
                                no: "allowSaleProduct",
                                disabled: _vm.readonly,
                                clearable: "",
                                "data-filter-function": function(p) {
                                  return p.statusEnabled && p.seaImportEnabled
                                },
                                "default-value": this.job.saleProductCode || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  this$1.job.saleProductCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { slot: "fullOrInside" },
                            slot: "fullOrInside"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_FullOrInside$FULL_OR_INSIDE,
                                no: "fullOrInside",
                                disabled: _vm.readonly,
                                clearable: "",
                                "default-value": this.job.fullOrInside || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  this$1.job.fullOrInside = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.elementDict.customerProperty.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customerProperty" },
                          slot: "customerProperty"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customerProperty.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customerProperty.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.customerTip,
                                placement: "bottom"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.customerLevel.customerName,
                                      expression: "customerLevel.customerName"
                                    }
                                  ],
                                  staticStyle: { color: "#FD9A14" }
                                },
                                [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.customerLevel.customerName,
                                      expression: "customerLevel.customerName"
                                    }
                                  ],
                                  staticStyle: { color: "#D3A73B" }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.customerLevel.customerName)
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.contractStatusLabel,
                                      expression: "contractStatusLabel"
                                    }
                                  ],
                                  staticClass: "red"
                                },
                                [
                                  _vm._v(
                                    " (" + _vm._s(_vm.contractStatusLabel) + ")"
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.advancePaymentLabel,
                                      expression: "advancePaymentLabel"
                                    }
                                  ],
                                  staticStyle: { color: "brown" }
                                },
                                [
                                  _vm._v(
                                    " (" + _vm._s(_vm.advancePaymentLabel) + ")"
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.stampPictureView.businessDocuments
                                          .length > 0,
                                      expression:
                                        "stampPictureView.businessDocuments.length > 0"
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      _vm.stampPictureView.visible = true
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: { "text-align": "right" },
                                    attrs: {
                                      title: _vm.$t("Message.BookingSeal"),
                                      src: _vm.stampIcon,
                                      height: "14"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customerContact.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customerContact" },
                          slot: "customerContact"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customerContact.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customerContact.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    no: "20",
                                    disabled: _vm.readonly,
                                    filterable: "",
                                    "allow-create": true
                                  },
                                  on: { change: _vm.tfLinkmanHandler },
                                  model: {
                                    value: _vm.job.customerContact,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "customerContact", $$v)
                                    },
                                    expression: "job.customerContact"
                                  }
                                },
                                _vm._l(_vm.contactList, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.contactPerson,
                                      value: item.contactPerson
                                    }
                                  })
                                }),
                                1
                              ),
                              _c(
                                "el-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isShowContactPersonDetail,
                                      expression: "!isShowContactPersonDetail"
                                    }
                                  ],
                                  attrs: { no: "21" },
                                  on: {
                                    click: function($event) {
                                      _vm.showContactsInfoDialog = true
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.contactTelephone.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "contactTelephone" },
                          slot: "contactTelephone"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.contactTelephone.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.contactTelephone.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "22", disabled: _vm.readonly },
                            model: {
                              value: _vm.job.contactTelephone,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "contactTelephone", $$v)
                              },
                              expression: "job.contactTelephone"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.contactFax.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "contactFax" }, slot: "contactFax" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.contactFax.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.contactFax.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "23", disabled: _vm.readonly },
                            model: {
                              value: _vm.job.contactFax,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "contactFax", $$v)
                              },
                              expression: "job.contactFax"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.cargoSource.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoSource.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoSource.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "24",
                                disabled:
                                  _vm.readonly || _vm.isCrossTenantSEToSI,
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                size: "mini"
                              },
                              on: {
                                change: function(val) {
                                  _vm.pm.cargoSourceChange(val)
                                  _vm.OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(
                                    _vm.view
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.cargoSource,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cargoSource", $$v)
                                },
                                expression: "job.cargoSource"
                              }
                            },
                            _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customJobType.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customJobType" },
                          slot: "customJobType"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customJobType.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customJobType.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "25",
                              filterable: "",
                              clearable: true,
                              placeholder: _vm.$t("SeaExport.PleaseSelect"),
                              disabled: _vm.readonly,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              "default-value": _vm.job.customJobType,
                              "static-options": _vm.customJobTypeList,
                              "method-params": { type: _vm.job.lob }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customJobType = p.value
                                _vm.onCustomJobTypeChange(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.secondaryCustomJobType
                              .slaveVisible &&
                            _vm.job.customJobType &&
                            _vm.secondaryCustomJobTypeList.length > 0,
                          expression:
                            "elementDict.secondaryCustomJobType.slaveVisible && job.customJobType && secondaryCustomJobTypeList.length > 0"
                        }
                      ],
                      attrs: { slot: "secondaryCustomJobType" },
                      slot: "secondaryCustomJobType"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondaryCustomJobType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondaryCustomJobType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "secondaryCustomJobType",
                        attrs: {
                          no: "secondaryCustomJobType",
                          disabled: _vm.readonly,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          cache: false,
                          "default-value": _vm.job.secondaryCustomJobType,
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.secondaryCustomJobTypeList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.secondaryCustomJobType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.salesChannel.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "salesChannel" },
                          slot: "salesChannel"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.salesChannel.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.salesChannel.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "26", disabled: true },
                            model: {
                              value: _vm.job.salesChannel,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "salesChannel", $$v)
                              },
                              expression: "job.salesChannel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.channelNo.slaveVisible && _vm.showChannelNo
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "channelNo" }, slot: "channelNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.channelNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.channelNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "27",
                              value: _vm.job.channelNo,
                              disabled: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.designationAgent.slaveVisible &&
                            _vm.visibleDesignationAgent,
                          expression:
                            "elementDict.designationAgent.slaveVisible && visibleDesignationAgent"
                        }
                      ],
                      attrs: { slot: "designationAgent" },
                      slot: "designationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.designationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.designationAgent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageC,
                                  expression: "sopImageC"
                                }
                              ],
                              attrs: {
                                no: "28",
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("div", [
                                _c("img", {
                                  class:
                                    _vm.job.designationAgent && _vm.readonly
                                      ? ""
                                      : "not-click",
                                  staticStyle: {
                                    padding: "5px 0",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    src: _vm.sopPic,
                                    width: "18",
                                    height: "28"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.sopChangeBookingAgentHandler()
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.creditTip.showWarningImageC,
                                  expression: "creditTip.showWarningImageC"
                                }
                              ],
                              attrs: {
                                content: _vm.creditTip.warningImageCTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-company-select", {
                            ref: "designationAgent",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "29",
                              disabled: !_vm.controllerEnable
                                .txtDesignationAgent,
                              "method-params": {
                                designationAgent: true,
                                active: false
                              },
                              "check-credit": true,
                              job: _vm.job,
                              "default-value": _vm.job.designationAgent || "",
                              "tag-name": "englishName"
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.designationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.elementDict.trustFromJob.slaveVisible &&
                  (!_vm.showChannelNo || _vm.isCrossTenantSEToSI)
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "trustFromJob" },
                          slot: "trustFromJob"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.trustFromJob.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.trustFromJob.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "30",
                              value: _vm.job.trustFromJob,
                              disabled: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.relatedJob &&
                  _vm.elementDict.relatedJob.slaveVisible &&
                  (!_vm.showChannelNo || _vm.isCrossTenantSEToSI)
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "relatedJob" }, slot: "relatedJob" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.relatedJob.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.relatedJob.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "relatedJob",
                              value: _vm.job.relatedJob,
                              disabled: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.destinationAgent.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "destinationAgent" },
                          slot: "destinationAgent"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.destinationAgent.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.destinationAgent.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.sopImageB,
                                      expression: "sopImageB"
                                    }
                                  ],
                                  attrs: {
                                    no: "31",
                                    content: _vm.$t("SeaExport.SOPReceiver"),
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticStyle: {
                                        padding: "5px 0",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        src: _vm.sopPic,
                                        width: "18",
                                        height: "28"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.sopChangeHandler()
                                        }
                                      }
                                    })
                                  ])
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.creditTip.showWarningImageB,
                                      expression: "creditTip.showWarningImageB"
                                    }
                                  ],
                                  attrs: {
                                    content: _vm.creditTip.warningImageBTip,
                                    placement: "right-end"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning red",
                                    staticStyle: { cursor: "pointer" }
                                  })
                                ]
                              ),
                              _c("cargo-company-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "32",
                                  disabled:
                                    _vm.readonly || _vm.isCrossTenantSEToSI,
                                  "method-params": {
                                    overseaAgent: true,
                                    active: true
                                  },
                                  "default-value":
                                    _vm.job.destinationAgent || "",
                                  "check-credit": true,
                                  job: _vm.job,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.txtDestinationAgentChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.carrierId.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "carrierId" }, slot: "carrierId" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.carrierId.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.carrierId.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-company-select", {
                            attrs: {
                              no: "33",
                              disabled: !_vm.controllerEnable.txtCarrierId,
                              "method-params": {
                                companyLob: "seaImport",
                                seaCmp: true,
                                active: true
                              },
                              "default-value": _vm.job.carrierId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.job.carrierId = p.value
                                _vm.onCarrierIdChange(
                                  this$1.scacList,
                                  this$1.carrierScacEdit
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.carrierScac &&
                  _vm.elementDict.carrierScac.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "carrierScac" }, slot: "carrierScac" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.carrierScac.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.carrierScac.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "carrierScac",
                              filterable: "",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.code +
                                  "]" +
                                  (item.englishName
                                    ? item.englishName
                                    : item.code)
                                )
                              },
                              "filter-tag-names": ["code", "englishName"],
                              "show-custom-label-in-option": true,
                              "static-options": _vm.scacList,
                              "tag-value": "code",
                              disabled:
                                _vm.readonly ||
                                !_vm.carrierScacEdit ||
                                !_vm.elementDict.carrierScac.writable,
                              "default-value": _vm.job.carrierScac || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.carrierScac = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.bookingAgent.slaveVisible &&
                  _vm.bookingAgentVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "bookingAgent" },
                          slot: "bookingAgent"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.bookingAgent.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.bookingAgent.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-company-select", {
                            attrs: {
                              no: "34",
                              disabled: !_vm.controllerEnable.txtBookingAgent,
                              "method-params": {
                                bookingAgent: true,
                                companyLob: "seaImport",
                                active: true
                              },
                              "default-value": _vm.job.bookingAgent || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.job.bookingAgent = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.exChangeAgent.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "exChangeAgent" },
                          slot: "exChangeAgent"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.exChangeAgent.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.exChangeAgent.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-company-select", {
                            attrs: {
                              no: "130",
                              disabled: _vm.readonly,
                              "method-params": {
                                bookingAgent: true,
                                companyLob: "seaImport",
                                active: true
                              },
                              "default-value": _vm.job.exChangeAgent || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.job.exChangeAgent = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.mbl.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "mbl" }, slot: "mbl" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.mbl.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-input", {
                                attrs: {
                                  no: "35",
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.pm.lclMasterFlag ||
                                    _vm.isCrossTenantSEToSI,
                                  "auto-uppercase": _vm.isUppercase
                                },
                                on: { change: _vm.mbl_Change },
                                model: {
                                  value: _vm.job.mbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "mbl", $$v)
                                  },
                                  expression: "job.mbl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.hbl.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "hbl" }, slot: "hbl" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.hbl.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.hbl.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "36",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "auto-uppercase": _vm.isUppercase
                            },
                            on: { change: _vm.updateHBL },
                            model: {
                              value: _vm.job.hbl,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "hbl", $$v)
                              },
                              expression: "job.hbl"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customsHbl.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "customsHbl" }, slot: "customsHbl" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customsHbl.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customsHbl.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "37",
                              disabled: _vm.readonly,
                              "auto-uppercase": _vm.isUppercase
                            },
                            on: { change: _vm.customsHblChange },
                            model: {
                              value: _vm.job.customsHbl,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customsHbl", $$v)
                              },
                              expression: "job.customsHbl"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.jobSoNo.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "jobSoNo" }, slot: "jobSoNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.jobSoNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.jobSoNo.label
                            },
                            slot: "label"
                          }),
                          _c("so-no-input", {
                            attrs: { no: "38", disabled: _vm.readonly },
                            model: {
                              value: _vm.job.jobSoNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "jobSoNo", $$v)
                              },
                              expression: "job.jobSoNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.vessel.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "vessel" }, slot: "vessel" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.vessel.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.vessel.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "39",
                              disabled:
                                _vm.readonly ||
                                !_vm.pm.lclMasterFlag ||
                                _vm.isCrossTenantSEToSI,
                              "auto-uppercase": true
                            },
                            model: {
                              value: _vm.job.vessel,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "vessel", $$v)
                              },
                              expression: "job.vessel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.voyageFlight.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "voyageFlight" },
                          slot: "voyageFlight"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.voyageFlight.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.voyageFlight.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c("cargo-input", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "40",
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.pm.lclMasterFlag ||
                                    _vm.isCrossTenantSEToSI,
                                  "auto-uppercase": true
                                },
                                on: { focus: _vm.loadVoyageFlight },
                                model: {
                                  value: _vm.job.voyageFlight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "voyageFlight", $$v)
                                  },
                                  expression: "job.voyageFlight"
                                }
                              }),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "5px" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { disabled: _vm.readonly },
                                      model: {
                                        value: _vm.isTwoVessel,
                                        callback: function($$v) {
                                          _vm.isTwoVessel = $$v
                                        },
                                        expression: "isTwoVessel"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.SecondCheck"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.secondVessel.slaveVisible && _vm.isTwoVessel
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "secondVessel" },
                          slot: "secondVessel"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.secondVessel.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.secondVessel.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "41",
                              disabled: _vm.readonly,
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.job.secondVessel,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "secondVessel", $$v)
                              },
                              expression: "job.secondVessel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.secondVoyage.slaveVisible && _vm.isTwoVessel
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "secondVoyage" },
                          slot: "secondVoyage"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.secondVoyage.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.secondVoyage.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "42",
                              disabled: _vm.readonly,
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.job.secondVoyage,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "secondVoyage", $$v)
                              },
                              expression: "job.secondVoyage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.dispatchingPlace.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "dispatchingPlace" },
                          slot: "dispatchingPlace"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.dispatchingPlace.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.dispatchingPlace.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "43",
                              disabled: _vm.readonly,
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.job.dispatchingPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "dispatchingPlace", $$v)
                              },
                              expression: "job.dispatchingPlace"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.loadingPortCode.slaveVisible,
                          expression: "elementDict.loadingPortCode.slaveVisible"
                        }
                      ],
                      attrs: { slot: "loadingPortCode" },
                      slot: "loadingPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "loadingPortCode",
                        attrs: {
                          no: "44",
                          filterable: "",
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                          placeholder: _vm.$t("SeaExport.RequiredItem"),
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          "default-value": _vm.job.loadingPortCode,
                          "tag-name": "englishName",
                          "method-params": {}
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.changeLoadingPortCode(p)
                            _vm.pm.checkVesselLine()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.dischargingPortCode.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "dischargingPortCode" },
                          slot: "dischargingPortCode"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.dischargingPortCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.dischargingPortCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "45",
                              filterable: "",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              placeholder: _vm.$t("SeaExport.RequiredItem"),
                              "callback-params": { key: "dischargingPortCode" },
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "default-value": _vm.job.dischargingPortCode,
                              "tag-name": "englishName",
                              "method-params": {}
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.dischargingPortCode = p.value
                                _vm.pm.dischargingPortCodeChange(p.value)
                                _vm.pm.changeDischargingPort2()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.destinationPortCode.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "destinationPortCode" },
                          slot: "destinationPortCode"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.destinationPortCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.destinationPortCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "destinationPortCode",
                              disabled: _vm.readonly,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.job.destinationPortCode,
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.destinationPortCode = p.value
                                _vm.pm.destinationPortCodeEasyChange(p)
                                _vm.pm.changeDestinationPort()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.destinationPlace.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "destinationPlace" },
                          slot: "destinationPlace"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.destinationPlace.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.destinationPlace.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: { no: "46", disabled: _vm.readonly },
                            on: {
                              change: function($event) {
                                return _vm.pm.changeDestinationPort()
                              }
                            },
                            model: {
                              value: _vm.job.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPlace", $$v)
                              },
                              expression: "job.destinationPlace"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.vesselLine.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "vesselLine" }, slot: "vesselLine" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.vesselLine.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.vesselLine.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "47",
                              value: _vm.job.loadingPortCode
                                ? _vm.pm.vesselLine
                                : "",
                              disabled: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customsDate.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "customsDate" }, slot: "customsDate" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customsDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customsDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "48",
                              disabled: _vm.readonly,
                              clearable: "",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.job.customsDate,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customsDate", $$v)
                              },
                              expression: "job.customsDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.bookingDate.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "bookingDate" }, slot: "bookingDate" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.bookingDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.bookingDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "49",
                              disabled: _vm.readonly,
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.job.bookingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "bookingDate", $$v)
                              },
                              expression: "job.bookingDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.etd.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "etd" }, slot: "etd" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.etd.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.etd.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: {
                                  flex: "1",
                                  width: "170px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "50",
                                  disabled:
                                    !_vm.controllerEnable.dfETD ||
                                    !_vm.pm.lclMasterFlag ||
                                    _vm.isCrossTenantSEToSI,
                                  placeholder: _vm.elementDict.etd.isRequire
                                    ? _vm.$t("SeaExport.RequiredItem")
                                    : "",
                                  type: "date",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { input: _vm.etdChange },
                                model: {
                                  value: _vm.job.etd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "etd", $$v)
                                  },
                                  expression: "job.etd"
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterWeek")(_vm.job.sailingDay)
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.eta.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "eta" }, slot: "eta" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.eta.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.eta.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: {
                                  flex: "1",
                                  width: "170px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "51",
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.pm.lclMasterFlag ||
                                    _vm.provisionEtdLocked,
                                  placeholder: _vm.$t("SeaExport.RequiredItem"),
                                  type: "date",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { input: _vm.etaChange },
                                model: {
                                  value: _vm.job.eta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "eta", $$v)
                                  },
                                  expression: "job.eta"
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterWeek")(_vm.job.etaSailingDay)
                                  )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm.provisionEtdLocked
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "red",
                                    "font-size": "12px"
                                  }
                                },
                                [_vm._v("(已计提校准不可修改)")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.atd.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "atd" }, slot: "atd" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.atd.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.atd.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: {
                                  flex: "1",
                                  width: "170px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "52",
                                  disabled:
                                    _vm.readonly || !_vm.pm.lclMasterFlag,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { input: _vm.atdChange },
                                model: {
                                  value: _vm.job.atd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "atd", $$v)
                                  },
                                  expression: "job.atd"
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterWeek")(_vm.job.atdSailingDay)
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.ata.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "ata" }, slot: "ata" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.ata.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.ata.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: {
                                  flex: "1",
                                  width: "170px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "53",
                                  disabled:
                                    _vm.readonly || !_vm.pm.lclMasterFlag,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { input: _vm.ataChange },
                                model: {
                                  value: _vm.job.ata,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "ata", $$v)
                                  },
                                  expression: "job.ata"
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterWeek")(_vm.job.ataSailingDay)
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.arrivalTime.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "arrivalTime" }, slot: "arrivalTime" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.arrivalTime.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.arrivalTime.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "123",
                              disabled: _vm.readonly,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.job.arrivalTime,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "arrivalTime", $$v)
                              },
                              expression: "job.arrivalTime"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customsBroker.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customsBroker" },
                          slot: "customsBroker"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customsBroker.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customsBroker.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "54",
                              disabled:
                                _vm.readonly ||
                                (_vm.isEdit && !_vm.job.customs),
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "data-filter-function": _vm.customsBrokerFilter,
                              filterable: "",
                              "default-value": _vm.job.customsBroker || "",
                              placeholder: _vm.job.customs
                                ? ""
                                : _vm.$t(
                                    "SeaExport.PleaseTickCustomsDeclarationOption"
                                  ),
                              "method-params": {
                                customsBroker: true,
                                companyLob: "seaImport",
                                active: true
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.customsBrokerChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customClaim.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "customClaim" }, slot: "customClaim" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customClaim.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customClaim.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethod",
                              disabled:
                                _vm.readonly ||
                                (_vm.isEdit && !_vm.job.customs),
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 2 },
                              "tag-value": "serialNum",
                              filterable: "",
                              "default-value": _vm.job.customClaim
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customClaim = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customsDeclarationType.slaveVisible &&
                  _vm.job.customClaim === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customsDeclarationType" },
                          slot: "customsDeclarationType"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customsDeclarationType
                              .isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label:
                                _vm.elementDict.customsDeclarationType.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsDeclarationType",
                              disabled:
                                _vm.readonly ||
                                (_vm.isEdit && !_vm.job.customs),
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_CustomsDeclarationType,
                              filterable: "",
                              "default-value":
                                _vm.job.customsDeclarationType === -1
                                  ? ""
                                  : _vm.job.customsDeclarationType,
                              placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customsDeclarationType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.tradeTerm.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.tradeTerm.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.tradeTerm.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "55",
                              disabled: _vm.readonly,
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames.basic_data_TradeTerm,
                              filterable: "",
                              "default-value": _vm.job.tradeTerm
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.tradeTerm = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.bookingTerm.slaveVisible,
                          expression: "elementDict.bookingTerm.slaveVisible"
                        }
                      ],
                      attrs: { slot: "bookingTerm" },
                      slot: "bookingTerm"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingTerm.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          ref: "bookingTerm",
                          attrs: {
                            no: "56",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("SeaExport.PleaseSelect"),
                            clearable: false,
                            size: "mini"
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.editInputVesselModel()
                            }
                          },
                          model: {
                            value: _vm.job.bookingTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "bookingTerm", $$v)
                            },
                            expression: "job.bookingTerm"
                          }
                        },
                        _vm._l(_vm.bookingTerms, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.elementDict.scNo.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "scNo" }, slot: "scNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.scNo.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.scNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "57", disabled: _vm.readonly },
                            model: {
                              value: _vm.job.scNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "scNo", $$v)
                              },
                              expression: "job.scNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.freeDemurrage.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "freeDemurrage" },
                          slot: "freeDemurrage"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.freeDemurrage.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.freeDemurrage.label
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              precision: 0,
                              min: 0,
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.job.freeDemurrage,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "freeDemurrage", $$v)
                              },
                              expression: "job.freeDemurrage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.freeDetention.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "freeDetention" },
                          slot: "freeDetention"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.freeDetention.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.freeDetention.label
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              no: "58",
                              precision: 0,
                              min: 0,
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.job.freeDetention,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "freeDetention", $$v)
                              },
                              expression: "job.freeDetention"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.terminalCompany.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "terminalCompany" },
                          slot: "terminalCompany"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.terminalCompany.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.terminalCompany.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-company-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "terminalCompany",
                              disabled: _vm.readonly,
                              "method-params": {
                                terminalCompany: true,
                                companyLob: "seaImport",
                                active: true
                              },
                              "default-value": _vm.job.terminalCompany || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.JobUtils.terminalCompanyChangeHandler(
                                  _vm.job,
                                  p
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.deliveryAddress.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "deliveryAddress" },
                          slot: "deliveryAddress"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.deliveryAddress.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.deliveryAddress.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "deliveryAddress",
                              disabled: _vm.readonly
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("Message.TerminalAddress"),
                                  _vm.job.deliveryAddress,
                                  function(val) {
                                    _vm.job.deliveryAddress = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.deliveryAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "deliveryAddress", $$v)
                              },
                              expression: "job.deliveryAddress"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.transportSource.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "transportSource" },
                          slot: "transportSource"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.transportSource.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.transportSource.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_TransportSource,
                              no: "transportSource",
                              "default-value": _vm.job.transportSource,
                              cache: false,
                              disabled: _vm.readonly,
                              "tag-value": "code",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.job.transportSource = item.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.statisticArea.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "statisticArea" },
                          slot: "statisticArea"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.statisticArea.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.statisticArea.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_StatisticArea,
                              no: "statisticArea",
                              "default-value": _vm.job.statisticArea,
                              cache: false,
                              disabled: _vm.readonly,
                              "tag-value": "code",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.job.statisticArea = item.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.deliverDate.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "deliverDate" }, slot: "deliverDate" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.deliverDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.deliverDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "59",
                              disabled: _vm.readonly,
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              clearable: ""
                            },
                            model: {
                              value: _vm.job.deliverDate,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "deliverDate", $$v)
                              },
                              expression: "job.deliverDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.arriveStorageDate.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "arriveStorageDate" },
                          slot: "arriveStorageDate"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.arriveStorageDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.arriveStorageDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "60",
                              disabled: _vm.readonly,
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              clearable: ""
                            },
                            model: {
                              value: _vm.job.arriveStorageDate,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "arriveStorageDate", $$v)
                              },
                              expression: "job.arriveStorageDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.shipper.slaveVisible
                    ? _c(
                        "template",
                        { slot: "shipper" },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "flex-end"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "61",
                                      type: "primary",
                                      disabled: _vm.readonly
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onExcerption()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.CopyFromOtherBill")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "62",
                                      type: "primary",
                                      disabled: _vm.readonly
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onCodeSearch()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("line-label", {
                                    class: _vm.elementDict.shipper.isRequire
                                      ? "blue"
                                      : "",
                                    attrs: {
                                      label: _vm.elementDict.shipper.label
                                    }
                                  }),
                                  _c("char-count", {
                                    staticStyle: {
                                      position: "static",
                                      display: "block",
                                      "font-size": "10px",
                                      color: "#909399"
                                    },
                                    attrs: { form: _vm.job, prefix: "shipper" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between"
                                  }
                                },
                                [
                                  _c("cargo-input", {
                                    staticStyle: {
                                      width: "80px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      no: "63",
                                      disabled: _vm.readonly,
                                      placeholder: _vm.readonly
                                        ? ""
                                        : _vm.$t("SeaExport.Code2"),
                                      "auto-uppercase":
                                        _vm.notUppercaseShipperConsigneNotify
                                    },
                                    model: {
                                      value: _vm.job.shipperCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "shipperCode", $$v)
                                      },
                                      expression: "job.shipperCode"
                                    }
                                  }),
                                  _c("cargo-company-select", {
                                    staticStyle: {
                                      flex: "1",
                                      "margin-bottom": "10px"
                                    },
                                    attrs: {
                                      no: "64",
                                      disabled: _vm.readonly,
                                      "method-params": {
                                        shipper: true,
                                        active: true
                                      },
                                      "default-value": _vm.job.shipperId || "",
                                      "tag-name": "englishName"
                                    },
                                    on: {
                                      change: function(data) {
                                        _vm.senderAndReceiverChange(
                                          "shipper",
                                          data,
                                          7
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("cargo-input", {
                                attrs: {
                                  no: "65",
                                  disabled: _vm.readonly,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t(
                                        "SeaExport.BillsOfLadingDoubleClickEject"
                                      ),
                                  "use-read-only": true
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.pm.shipperAddrChangeFunc()
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showSenderAndReceiverDialog(
                                      "shipper",
                                      7,
                                      false,
                                      _vm.notUppercaseShipperConsigneNotify
                                    )
                                    _vm.focusAdvanceTextInput()
                                  }
                                },
                                model: {
                                  value: _vm.job.shipperLine1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine1", $$v)
                                  },
                                  expression: "job.shipperLine1"
                                }
                              }),
                              _c("cargo-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                attrs: { no: "shipperLine2" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.shipperAddrChangeFunc()
                                  }
                                },
                                model: {
                                  value: _vm.job.shipperLine2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine2", $$v)
                                  },
                                  expression: "job.shipperLine2"
                                }
                              }),
                              _c("cargo-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                attrs: { no: "shipperLine3" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.shipperAddrChangeFunc()
                                  }
                                },
                                model: {
                                  value: _vm.job.shipperLine3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine3", $$v)
                                  },
                                  expression: "job.shipperLine3"
                                }
                              }),
                              _c("cargo-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                attrs: { no: "shipperLine4" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.shipperAddrChangeFunc()
                                  }
                                },
                                model: {
                                  value: _vm.job.shipperLine4,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine4", $$v)
                                  },
                                  expression: "job.shipperLine4"
                                }
                              }),
                              _c("cargo-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                attrs: { no: "shipperLine5" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.shipperAddrChangeFunc()
                                  }
                                },
                                model: {
                                  value: _vm.job.shipperLine5,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine5", $$v)
                                  },
                                  expression: "job.shipperLine5"
                                }
                              }),
                              _c("cargo-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                attrs: { no: "shipperLine6" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.shipperAddrChangeFunc()
                                  }
                                },
                                model: {
                                  value: _vm.job.shipperLine6,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine6", $$v)
                                  },
                                  expression: "job.shipperLine6"
                                }
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.consignee.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "consignee" }, slot: "consignee" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.consignee.isRequire
                                  ? "blue"
                                  : "",
                                attrs: {
                                  label: _vm.elementDict.consignee.label
                                }
                              }),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.job, prefix: "consignee" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c("cargo-input", {
                                staticStyle: {
                                  width: "80px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "66",
                                  disabled: _vm.readonly,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("SeaExport.Code2"),
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.qConsigneeCode_focusOutHandler()
                                  }
                                },
                                model: {
                                  value: _vm.job.consigneeCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "consigneeCode", $$v)
                                  },
                                  expression: "job.consigneeCode"
                                }
                              }),
                              _c("cargo-company-select", {
                                staticStyle: {
                                  flex: "1",
                                  "margin-bottom": "10px"
                                },
                                attrs: {
                                  no: "67",
                                  disabled: _vm.readonly,
                                  "method-params": {
                                    consignee: true,
                                    active: true
                                  },
                                  "default-value": _vm.job.consigneeId || "",
                                  "tag-name": "englishName"
                                },
                                on: {
                                  change: function(data) {
                                    _vm.senderAndReceiverChange(
                                      "consignee",
                                      data,
                                      7,
                                      true,
                                      _vm.notUppercaseShipperConsigneNotify
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c("cargo-input", {
                            attrs: {
                              no: "68",
                              disabled: _vm.readonly,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.BillsOfLadingDoubleClickEject"
                                  ),
                              "use-read-only": true
                            },
                            on: {
                              blur: function($event) {
                                _vm.pm.qConsigneeAddr_focusOutHandler()
                                _vm.pm.consigneeAddrChangeFunc()
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showSenderAndReceiverDialog(
                                  "consignee",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                                _vm.focusAdvanceTextInput()
                              }
                            },
                            model: {
                              value: _vm.job.consigneeLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeLine1", $$v)
                              },
                              expression: "job.consigneeLine1"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "consigneeLine2" },
                            on: {
                              change: function($event) {
                                return _vm.pm.consigneeAddrChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.consigneeLine2,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeLine2", $$v)
                              },
                              expression: "job.consigneeLine2"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "consigneeLine3" },
                            on: {
                              change: function($event) {
                                return _vm.pm.consigneeAddrChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.consigneeLine3,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeLine3", $$v)
                              },
                              expression: "job.consigneeLine3"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "consigneeLine4" },
                            on: {
                              change: function($event) {
                                return _vm.pm.consigneeAddrChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.consigneeLine4,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeLine4", $$v)
                              },
                              expression: "job.consigneeLine4"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "consigneeLine5" },
                            on: {
                              change: function($event) {
                                return _vm.pm.consigneeAddrChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.consigneeLine5,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeLine5", $$v)
                              },
                              expression: "job.consigneeLine5"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "consigneeLine6" },
                            on: {
                              change: function($event) {
                                return _vm.pm.consigneeAddrChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.consigneeLine6,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeLine6", $$v)
                              },
                              expression: "job.consigneeLine6"
                            }
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.elementDict.notify.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "notify" }, slot: "notify" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.notify.isRequire
                                  ? "blue"
                                  : "",
                                attrs: { label: _vm.elementDict.notify.label }
                              }),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.job, prefix: "notify" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c("cargo-input", {
                                staticStyle: {
                                  width: "80px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "69",
                                  disabled: _vm.readonly,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("SeaExport.Code2"),
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify
                                },
                                model: {
                                  value: _vm.job.notifyCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "notifyCode", $$v)
                                  },
                                  expression: "job.notifyCode"
                                }
                              }),
                              _c("cargo-company-select", {
                                staticStyle: {
                                  flex: "1",
                                  "margin-bottom": "10px"
                                },
                                attrs: {
                                  no: "70",
                                  disabled: _vm.readonly,
                                  "method-params": {
                                    notify: true,
                                    active: true
                                  },
                                  "default-value": _vm.job.notifyId || "",
                                  "tag-name": "englishName"
                                },
                                on: {
                                  change: function(data) {
                                    _vm.senderAndReceiverChange(
                                      "notify",
                                      data,
                                      7
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c("cargo-input", {
                            attrs: {
                              no: "71",
                              disabled: _vm.readonly,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.BillsOfLadingDoubleClickEject"
                                  ),
                              "use-read-only": true
                            },
                            on: {
                              blur: function($event) {
                                return _vm.pm.notifyChangeFunc()
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showSenderAndReceiverDialog(
                                  "notify",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                                _vm.focusAdvanceTextInput()
                              }
                            },
                            model: {
                              value: _vm.job.notifyLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyLine1", $$v)
                              },
                              expression: "job.notifyLine1"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "notifyLine2" },
                            on: {
                              change: function($event) {
                                return _vm.pm.notifyChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.notifyLine2,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyLine2", $$v)
                              },
                              expression: "job.notifyLine2"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "notifyLine3" },
                            on: {
                              change: function($event) {
                                return _vm.pm.notifyChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.notifyLine3,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyLine3", $$v)
                              },
                              expression: "job.notifyLine3"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "notifyLine4" },
                            on: {
                              change: function($event) {
                                return _vm.pm.notifyChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.notifyLine4,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyLine4", $$v)
                              },
                              expression: "job.notifyLine4"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "notifyLine5" },
                            on: {
                              change: function($event) {
                                return _vm.pm.notifyChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.notifyLine5,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyLine5", $$v)
                              },
                              expression: "job.notifyLine5"
                            }
                          }),
                          _c("cargo-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { no: "notifyLine6" },
                            on: {
                              change: function($event) {
                                return _vm.pm.notifyChangeFunc()
                              }
                            },
                            model: {
                              value: _vm.job.notifyLine6,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyLine6", $$v)
                              },
                              expression: "job.notifyLine6"
                            }
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.elementDict.quantityActual.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "quantityActual" },
                          slot: "quantityActual"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.quantityActual.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.quantityActual.label
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              no: "72",
                              precision: 0,
                              min: 0,
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.quantityFocusInHandler()
                              }
                            },
                            model: {
                              value: _vm.job.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityActual", $$v)
                              },
                              expression: "job.quantityActual"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.packing.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "packing" }, slot: "packing" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.packing.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.packing.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-packing-select", {
                            attrs: {
                              no: "73",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "default-value": _vm.job.packing
                            },
                            on: {
                              change: function(p) {
                                _vm.job.packing = p.value
                                _vm.pm.chargePacking()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.weightActual.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "weightActual" },
                          slot: "weightActual"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.weightActual.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.weightActual.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "74",
                                  precision: 3,
                                  min: 0,
                                  disabled:
                                    _vm.readonly || _vm.isCrossTenantSEToSI
                                },
                                on: { change: _vm.weightContractChange },
                                model: {
                                  value: _vm.job.weightActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "weightActual", $$v)
                                  },
                                  expression: "job.weightActual"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.cubageActual.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "cubageActual" },
                          slot: "cubageActual"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cubageActual.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cubageActual.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "75",
                                  precision: 3,
                                  min: 0,
                                  disabled:
                                    _vm.readonly || _vm.isCrossTenantSEToSI
                                },
                                on: { change: _vm.cubageContractChange },
                                model: {
                                  value: _vm.job.cubageActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cubageActual", $$v)
                                  },
                                  expression: "job.cubageActual"
                                }
                              }),
                              _c("span", [_vm._v("CBM")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.chargeWeight.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "chargeWeight" },
                          slot: "chargeWeight"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.chargeWeight.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.chargeWeight.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "76",
                                  precision: 3,
                                  min: 0,
                                  disabled:
                                    !_vm.controllerEnable.txtChargeWeight ||
                                    _vm.isCrossTenantSEToSI
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.chargeWeightChangeHandler()
                                  }
                                },
                                model: {
                                  value: _vm.job.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "chargeWeight", $$v)
                                  },
                                  expression: "job.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("M/T")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.seaEq.slaveVisible &&
                            _vm.job.containerLoadType !== "LCL",
                          expression:
                            "elementDict.seaEq.slaveVisible && job.containerLoadType!=='LCL'"
                        }
                      ],
                      staticClass: "auto-width",
                      attrs: { slot: "seaEq", "label-width": "0" },
                      slot: "seaEq"
                    },
                    [
                      _vm.job.containerLoadType !== "BULK" &&
                      _vm.job.containerLoadType !== "LCL"
                        ? _c("booking-sea-eq-data-grid", {
                            attrs: {
                              value: _vm.seaEqList,
                              "container-load-type": _vm.job.containerLoadType,
                              "is-edit": _vm.isEdit,
                              job: _vm.job
                            },
                            on: {
                              eqQuantityChange: _vm.eqQuantityChangeHandler
                            }
                          })
                        : _vm._e(),
                      _vm.job.containerLoadType === "BULK"
                        ? _c("booking-bulk-data-grid", {
                            attrs: {
                              value: _vm.cargoBulkDetailList,
                              context: _vm.context,
                              "show-excel-button": false,
                              "job-uuid": _vm.job.uuid,
                              "is-edit": _vm.isEdit
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.elementDict.cargoEnglishName.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "cargoEnglishName" },
                          slot: "cargoEnglishName"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoEnglishName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoEnglishName.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              "show-count": true,
                              no: "77",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "text-chars": _vm.englishNameMaxChars,
                              "warning-count": _vm.englishNameWarningCount,
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.txtCargoEnglishNameChangeHandler()
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("queryJob.englishDescriptionOfGoods"),
                                  _vm.job.cargoEnglishName,
                                  function(val) {
                                    _vm.job.cargoEnglishName = val
                                  },
                                  false,
                                  null,
                                  _vm.isUppercaseByConfig,
                                  {
                                    warningCount: _vm.englishNameWarningCount,
                                    maxChar: _vm.englishNameMaxChars
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cargoEnglishName", $$v)
                              },
                              expression: "job.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.cargoChineseName.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "cargoChineseName" },
                          slot: "cargoChineseName"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoChineseName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoChineseName.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              "show-count": true,
                              no: "78",
                              disabled: _vm.readonly,
                              "text-chars": _vm.maxChars,
                              "warning-count": _vm.warningCount,
                              "auto-half-word": false
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                  _vm.job.cargoChineseName,
                                  function(val) {
                                    _vm.job.cargoChineseName = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cargoChineseName,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cargoChineseName", $$v)
                              },
                              expression: "job.cargoChineseName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.mark.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "mark" }, slot: "mark" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mark.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.mark.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              "show-count": true,
                              no: "79",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "text-chars": _vm.markMaxChars,
                              "warning-count": _vm.markWarningCount,
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            on: { change: _vm.onMarkChange },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.job.mark,
                                  function(val) {
                                    _vm.job.mark = val
                                  },
                                  false,
                                  null,
                                  _vm.isUppercaseByConfig,
                                  {
                                    warningCount: _vm.markWarningCount,
                                    maxChar: _vm.markMaxChars
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "mark", $$v)
                              },
                              expression: "job.mark"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.incoTerm.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.incoTerm.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.incoTerm.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "80",
                              filterable: "",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "select-type":
                                _vm.selectTypeNames.basic_data_IncoTerm,
                              "method-params": {},
                              "callback-method-type": "value",
                              "default-value": _vm.job.incoTerm + "",
                              "callback-params": { key: "incoTerm" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.depositReceived.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "depositReceived" },
                          slot: "depositReceived"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.depositReceived.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.depositReceived.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { "flex-grow": "1" },
                                attrs: {
                                  no: "81",
                                  value:
                                    _vm.job.depositReceived === 0
                                      ? undefined
                                      : _vm.job.depositReceived,
                                  disabled: _vm.readonly,
                                  controls: false,
                                  precision: 3
                                },
                                on: {
                                  input: function(val) {
                                    _vm.job.depositReceived = val
                                  }
                                }
                              }),
                              _c("span", [_vm._v(_vm._s(_vm.localCurrency))])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.remarks.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "remarks" }, slot: "remarks" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.remarks.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.remarks.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "82",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "text-chars": _vm.maxChars,
                              "warning-count": _vm.warningCount,
                              "is-trim": true
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Remarks"),
                                  _vm.job.remarks,
                                  function(val) {
                                    _vm.job.remarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "remarks", $$v)
                              },
                              expression: "job.remarks"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.cargoCode.slaveVisible
                    ? _c(
                        "template",
                        { slot: "cargoCode" },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                class: _vm.elementDict.cargoCode.isRequire
                                  ? "blue"
                                  : "",
                                attrs: {
                                  slot: "label",
                                  label: _vm.elementDict.cargoCode.label
                                },
                                slot: "label"
                              }),
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "83",
                                  "allow-create": false,
                                  clearable: true,
                                  "default-value": _vm.job.cargoCode,
                                  disabled: _vm.readonly,
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_CargoInformation,
                                  filterable: ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.cargoCodeChange(p.value)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "84",
                                  disabled: !(
                                    _vm.isEdit &&
                                    _vm.job.cargoCode !== "" &&
                                    _vm.job.cargoCode != null
                                  )
                                },
                                model: {
                                  value: _vm.job.cargoName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cargoName", $$v)
                                  },
                                  expression: "job.cargoName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.warehouseNo.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "warehouseNo" }, slot: "warehouseNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.warehouseNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.warehouseNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "85", disabled: true },
                            model: {
                              value: _vm.job.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "warehouseNo", $$v)
                              },
                              expression: "job.warehouseNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.containerLoadType.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "containerLoadType" },
                          slot: "containerLoadType"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.containerLoadType.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.containerLoadType.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              no: "86",
                              clearable: false,
                              disabled:
                                !_vm.controllerEnable.qCargoType ||
                                _vm.isCrossTenantSEToSI,
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_ImportConstants$_cargoTypeInputList,
                              "callback-method-type": "value",
                              "default-value": _vm.job.containerLoadType,
                              "tag-name":
                                _vm.$store.getters.language === "zh"
                                  ? "chineseName"
                                  : "englishName",
                              "tag-value": "code",
                              "callback-params": { key: "containerLoadType" }
                            },
                            on: {
                              parentCallBack: function(obj) {
                                return _vm.pm.qCargoType_Change(obj)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.poNo.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.poNoRed ? "poNoClass" : "",
                          attrs: { slot: "poNo" },
                          slot: "poNo"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.poNo.label
                            },
                            slot: "label"
                          }),
                          !_vm.openProjectConfig
                            ? _c("cargo-input", {
                                attrs: {
                                  no: "87",
                                  disabled: _vm.readonly,
                                  "auto-uppercase": _vm.isUppercase,
                                  "use-read-only": true
                                },
                                model: {
                                  value: _vm.job.poNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "poNo", $$v)
                                  },
                                  expression: "job.poNo"
                                }
                              })
                            : _vm._e(),
                          _vm.openProjectConfig
                            ? _c("cargo-project-select", {
                                attrs: {
                                  no: "88",
                                  disabled: _vm.readonly,
                                  "default-value": _vm.job.poNo,
                                  "customer-id": _vm.job.customerId,
                                  "is-linked": _vm.isProjectLinkedCustomer
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.poNo = p.value
                                    _vm.job.projectName = p.projectName
                                    _vm.pm.changeProject()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.projectName.slaveVisible &&
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            slot: "projectName",
                            label: _vm.$t("SeaExport.ProjectName")
                          },
                          slot: "projectName"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.projectName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.projectName.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "89", disabled: true },
                            model: {
                              value: _vm.job.projectName,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "projectName", $$v)
                              },
                              expression: "job.projectName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.projectBatch.slaveVisible &&
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            slot: "projectBatch",
                            label: _vm.$t("SeaExport.ProjectBatch")
                          },
                          slot: "projectBatch"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.projectBatch.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.projectBatch.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { no: "90", disabled: _vm.readonly },
                            model: {
                              value: _vm.job.projectBatch,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "projectBatch", $$v)
                              },
                              expression: "job.projectBatch"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.freightTermMBL.slaveVisible,
                          expression: "elementDict.freightTermMBL.slaveVisible"
                        }
                      ],
                      attrs: { slot: "freightTermMBL" },
                      slot: "freightTermMBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.freightTermMBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.freightTermMBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "freightTermMBL",
                        attrs: {
                          no: "91",
                          filterable: "",
                          clearable: false,
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          "method-params": {},
                          "callback-method-type": "value",
                          "default-value": _vm.job.freightTermMBL + "",
                          "callback-params": { key: "freightTermMBL" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.freightTermHBL.slaveVisible &&
                            !_vm.job.mblOnly,
                          expression:
                            "elementDict.freightTermHBL.slaveVisible && !job.mblOnly"
                        }
                      ],
                      attrs: { slot: "freightTermHBL" },
                      slot: "freightTermHBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.freightTermHBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.freightTermHBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "92",
                          filterable: "",
                          clearable: false,
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          "method-params": {},
                          "callback-method-type": "value",
                          "default-value": _vm.job.freightTermHBL + "",
                          "callback-params": { key: "freightTermHBL" }
                        },
                        on: {
                          parentCallBack: function(obj) {
                            return _vm.pm.freightTermHBLChange(obj)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.paymentTermMBL.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "paymentTermMBL" },
                          slot: "paymentTermMBL"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.paymentTermMBL.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.paymentTermMBL.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "93",
                              filterable: "",
                              clearable: false,
                              disabled:
                                _vm.readonly ||
                                !_vm.pm.lclMasterFlag ||
                                _vm.isCrossTenantSEToSI,
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              "method-params": {},
                              "callback-method-type": "value",
                              "default-value": _vm.job.paymentTermMBL + "",
                              "callback-params": { key: "paymentTermMBL" }
                            },
                            on: {
                              parentCallBack: function(obj) {
                                return _vm.pm.paymentTermMBLChange(obj)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.mblPaymentPlaceBL.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "mblPaymentPlaceBL" },
                          slot: "mblPaymentPlaceBL"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mblPaymentPlaceBL.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.mblPaymentPlaceBL.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isShowAcPaymentPlaceBL,
                                expression: "!isShowAcPaymentPlaceBL"
                              }
                            ],
                            attrs: { no: "94", disabled: _vm.readonly },
                            on: {
                              change: function($event) {
                                _vm.pm.fieldChangeHandler()
                                _vm.job.paymentPlaceMbl =
                                  _vm.mblDoc.paymentPlaceBL
                              }
                            },
                            model: {
                              value: _vm.mblDoc.paymentPlaceBL,
                              callback: function($$v) {
                                _vm.$set(_vm.mblDoc, "paymentPlaceBL", $$v)
                              },
                              expression: "mblDoc.paymentPlaceBL"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.paymentTermHBL.slaveVisible &&
                            !_vm.job.mblOnly,
                          expression:
                            "elementDict.paymentTermHBL.slaveVisible && !job.mblOnly"
                        }
                      ],
                      attrs: { slot: "paymentTermHBL" },
                      slot: "paymentTermHBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentTermHBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentTermHBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          no: "95",
                          clearable: false,
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          "method-params": {},
                          "callback-method-type": "value",
                          "default-value": _vm.job.paymentTermHBL + "",
                          "callback-params": { key: "paymentTermHBL" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.hblPaymentPlaceBL.slaveVisible &&
                            !_vm.job.mblOnly,
                          expression:
                            "elementDict.hblPaymentPlaceBL.slaveVisible && !job.mblOnly"
                        }
                      ],
                      attrs: { slot: "hblPaymentPlaceBL" },
                      slot: "hblPaymentPlaceBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.hblPaymentPlaceBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.hblPaymentPlaceBL.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { no: "96", disabled: _vm.readonly },
                        on: {
                          change: function($event) {
                            _vm.job.paymentPlaceHbl = _vm.hdoc.paymentPlaceBL
                          }
                        },
                        model: {
                          value: _vm.hdoc.paymentPlaceBL,
                          callback: function($$v) {
                            _vm.$set(_vm.hdoc, "paymentPlaceBL", $$v)
                          },
                          expression: "hdoc.paymentPlaceBL"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.cargoType.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "cargoType" }, slot: "cargoType" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoType.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoType.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              no: "97",
                              clearable: false,
                              disabled: _vm.readonly,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoType,
                              "callback-method-type": "value",
                              "default-value": _vm.job.cargoType,
                              "callback-params": { key: "cargoType" }
                            },
                            on: { parentCallBack: _vm.onCargoTypeChagne }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.releaseTypeHbl.slaveVisible &&
                            !_vm.job.mblOnly,
                          expression:
                            "elementDict.releaseTypeHbl.slaveVisible && !job.mblOnly"
                        }
                      ],
                      attrs: { slot: "releaseTypeHbl" },
                      slot: "releaseTypeHbl"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.releaseTypeHbl.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.releaseTypeHbl.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "98",
                          disabled: _vm.readonly,
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_ImportConstants$_importReleaseTypes,
                          "callback-method-type": "value",
                          "default-value": _vm.job.releaseTypeHbl,
                          headers: [_vm.$t("Tool.Code")],
                          fields: ["code"],
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          "tag-value": "code",
                          "callback-params": { key: "releaseTypeHbl" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.releaseTypeMbl.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "releaseTypeMbl" },
                          slot: "releaseTypeMbl"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.releaseTypeMbl.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.releaseTypeMbl.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "99",
                              disabled: _vm.readonly || !_vm.pm.lclMasterFlag,
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_ImportConstants$_importReleaseTypes,
                              "callback-method-type": "value",
                              "default-value": _vm.job.releaseTypeMbl,
                              headers: [_vm.$t("Tool.Code")],
                              fields: ["code"],
                              "tag-name": _vm.isZh
                                ? "chineseName"
                                : "englishName",
                              "tag-value": "code",
                              "callback-params": { key: "releaseTypeMbl" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.portDistrict.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "portDistrict" },
                          slot: "portDistrict"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.portDistrict.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.portDistrict.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "100",
                              disabled: _vm.readonly,
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.job.portDistrict,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "portDistrict", $$v)
                              },
                              expression: "job.portDistrict"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.vesselUnCode.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "vesselUnCode" },
                          slot: "vesselUnCode"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.vesselUnCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.vesselUnCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "101",
                              disabled: _vm.readonly,
                              "auto-uppercase": _vm.isUppercase
                            },
                            model: {
                              value: _vm.job.vesselUnCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "vesselUnCode", $$v)
                              },
                              expression: "job.vesselUnCode"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.transDate.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "transDate" }, slot: "transDate" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.transDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.transDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "102",
                              disabled: _vm.readonly,
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              clearable: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.dfCustDate_focusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.job.transDate,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transDate", $$v)
                              },
                              expression: "job.transDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.warehouseCmp.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "warehouseCmp" },
                          slot: "warehouseCmp"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.warehouseCmp.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.warehouseCmp.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-company-select", {
                            attrs: {
                              no: "103",
                              disabled:
                                _vm.readonly ||
                                (_vm.isEdit && !_vm.job.warehousing),
                              "method-params": {
                                warehouse: true,
                                active: true
                              },
                              "default-value": _vm.job.warehouseCmp || "",
                              placeholder: _vm.job.warehousing
                                ? ""
                                : _vm.$t("SeaExport.PleaseCheckWarehouses")
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.warehouseCmpChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.warehouseName.slaveVisible &&
                  _vm.openWarehouse
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "warehouseName" },
                          slot: "warehouseName"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.warehouseName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.warehouseName.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "warehouseName",
                                disabled:
                                  _vm.readonly ||
                                  (_vm.isEdit && !_vm.job.warehousing) ||
                                  !_vm.job.warehouseCmp,
                                "allow-create": true,
                                filterable: "",
                                clearable: true
                              },
                              on: { change: _vm.warehouseNameChangeHandler },
                              model: {
                                value: _vm.job.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "warehouseName", $$v)
                                },
                                expression: "job.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.txtSalesOffice.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "txtSalesOffice" },
                          slot: "txtSalesOffice"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.txtSalesOffice.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.txtSalesOffice.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "104",
                              disabled: true,
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            model: {
                              value: _vm.txtSalesOffice,
                              callback: function($$v) {
                                _vm.txtSalesOffice = $$v
                              },
                              expression: "txtSalesOffice"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.sales.slaveVisible,
                          expression: "elementDict.sales.slaveVisible"
                        }
                      ],
                      attrs: { slot: "sales" },
                      slot: "sales"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.sales.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.sales.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            ref: "sales",
                            attrs: {
                              no: "105",
                              disabled: !_vm.saleEnabled,
                              "method-params": {
                                officeId: _vm.salesOfficeCheck
                                  ? _vm.$store.getters.currentOfficeId
                                  : "",
                                category: "role",
                                shape: "sales"
                              },
                              "default-value": _vm.job.sales || "",
                              "static-options": _vm.salesList,
                              placeholder: _vm.salesPrompt
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.salesChangeHandler(p)
                              }
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: { disabled: true },
                              model: {
                                value: _vm.job.provisioned,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "provisioned", $$v)
                                },
                                expression: "job.provisioned"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.elementDict.cargoSalesId.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "cargoSalesId" },
                          slot: "cargoSalesId"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoSalesId.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoSalesId.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            attrs: {
                              no: "106",
                              disabled: _vm.readonly,
                              "method-params": {
                                category: "role",
                                shape: "salesOfGoods"
                              },
                              "default-value": _vm.job.cargoSalesId || "",
                              "static-options": _vm.cargoSalesList
                            },
                            on: {
                              change: function(p) {
                                _vm.job.cargoSalesId = p.value
                                _vm.pm.cargoSalesChargeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.salesDepartment.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "salesDepartment" },
                          slot: "salesDepartment"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.salesDepartment.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.salesDepartment.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-department-new-select", {
                            attrs: {
                              no: "107",
                              disabled:
                                _vm.readonly ||
                                (_vm.isEdit &&
                                  (_vm.job.sales === 0 || !_vm.job.sales)),
                              "sales-id": Number(_vm.job.sales),
                              "office-id": _vm.job.salesOffice,
                              "department-id": Number(_vm.job.salesDepartment),
                              enables: true
                            },
                            on: {
                              change: function(p) {
                                _vm.job.salesDepartment = p.value
                                _vm.pm.departmentChargeHandler()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.opOffice.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "opOffice" }, slot: "opOffice" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.opOffice.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.opOffice.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "108",
                              disabled: _vm.readonly || _vm.opOfficeDisabled,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office,
                              filterable: "",
                              "default-value": _vm.job.opOffice,
                              "static-options":
                                _vm.cacheOffices || _vm.allCacheOffices,
                              placeholder: ""
                            },
                            on: { parentCallBack: _vm.opOfficeChangeHandler }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.opDepartment.slaveVisible,
                          expression: "elementDict.opDepartment.slaveVisible"
                        }
                      ],
                      attrs: { slot: "opDepartment" },
                      slot: "opDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        ref: "department",
                        attrs: {
                          no: "109",
                          disabled: !_vm.saleEnabled,
                          "office-id": Number(_vm.job.opOffice),
                          enables: true,
                          "department-id": Number(_vm.job.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.op.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "op" }, slot: "op" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.op.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.op.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            attrs: {
                              disabled: _vm.readonly,
                              no: "110",
                              "method-params": {
                                officeId: _vm.job.opOffice,
                                category: "role",
                                shape: "siop"
                              },
                              "default-value": _vm.job.op || "",
                              "static-options": _vm.userPortRoleData.op
                            },
                            on: {
                              change: function(p) {
                                _vm.job.op = p.value
                                _vm.pm.opChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.csrOffice.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.csrOffice.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.csrOffice.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-office-select", {
                            attrs: {
                              no: "csrOffice",
                              disabled: true,
                              "office-id": Number(_vm.job.csrOffice)
                            },
                            on: {
                              change: function(p) {
                                _vm.job.csrOffice = p.value
                                _vm.job.csrDepartment = 0
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.csrDepartment.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "csrDepartment" },
                          slot: "csrDepartment"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.csrDepartment.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.csrDepartment.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "csrDepartment",
                              "office-id": Number(_vm.job.csrOffice),
                              enables: true,
                              disabled: _vm.readonly,
                              "department-id": Number(_vm.job.csrDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.job.csrDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.csr.slaveVisible,
                          expression: "elementDict.csr.slaveVisible"
                        }
                      ],
                      attrs: { slot: "csr" },
                      slot: "csr"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csr.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          no: "111",
                          disabled: _vm.readonly,
                          "method-params": { category: "role", shape: "csr" },
                          "default-value": _vm.job.csr || "",
                          "static-options": _vm.userPortRoleData.csr
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.dcOffice.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.dcOffice.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.dcOffice.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-office-select", {
                            attrs: {
                              no: "dcOffice",
                              disabled: true,
                              "office-id": Number(_vm.job.dcOffice)
                            },
                            on: {
                              change: function(p) {
                                _vm.job.dcOffice = p.value
                                _vm.job.dcDepartment = 0
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.dcDepartment.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "dcDepartment" },
                          slot: "dcDepartment"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.dcDepartment.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.dcDepartment.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "dcDepartment",
                              "office-id": Number(_vm.job.dcOffice),
                              enables: true,
                              disabled: _vm.readonly,
                              "department-id": Number(_vm.job.dcDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.job.dcDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.dc.slaveVisible,
                          expression: "elementDict.dc.slaveVisible"
                        }
                      ],
                      attrs: { slot: "dc" },
                      slot: "dc"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dc.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dc.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          no: "112",
                          disabled: _vm.readonly,
                          "method-params": { category: "role", shape: "doc" },
                          "default-value": _vm.job.dc || "",
                          "static-options": _vm.userPortRoleData.doc
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.plannerOffice &&
                  _vm.elementDict.plannerOffice.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "plannerOffice" },
                          slot: "plannerOffice"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.plannerOffice.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.plannerOffice.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-office-select", {
                            attrs: {
                              no: "plannerOffice",
                              disabled: true,
                              "office-id": Number(_vm.job.plannerOffice)
                            },
                            on: {
                              change: function(p) {
                                _vm.job.plannerOffice = p.value
                                _vm.job.plannerDepartment = 0
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.plannerDepartment &&
                  _vm.elementDict.plannerDepartment.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "plannerDepartment" },
                          slot: "plannerDepartment"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.plannerDepartment.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.plannerDepartment.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "plannerDepartment",
                              "office-id": Number(_vm.job.plannerOffice),
                              enables: true,
                              disabled: _vm.readonly,
                              "department-id": Number(_vm.job.plannerDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.job.plannerDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.planner.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "planner" }, slot: "planner" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.planner.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.planner.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            attrs: {
                              no: "113",
                              disabled: _vm.readonly,
                              "method-params": {
                                category: "role",
                                shape: "seaLine"
                              },
                              "default-value": _vm.job.planner || "",
                              "static-options": _vm.userPortRoleData.seaLine
                            },
                            on: {
                              change: function(p) {
                                _vm.job.planner = p.value
                                _vm.pm.txtPlannerChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.loadingPortOp.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "loadingPortOp" },
                          slot: "loadingPortOp"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.loadingPortOp.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.loadingPortOp.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            attrs: {
                              no: "114",
                              disabled: _vm.readonly,
                              "method-params": {
                                category: "role",
                                shape: "siop"
                              },
                              "default-value": _vm.job.loadingPortOp || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.job.loadingPortOp = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.destinationPortOp.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "destinationPortOp" },
                          slot: "destinationPortOp"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.destinationPortOp.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.destinationPortOp.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            attrs: {
                              no: "115",
                              disabled: _vm.readonly,
                              "method-params": {
                                category: "role",
                                shape: "siop"
                              },
                              "default-value": _vm.job.destinationPortOp || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.job.destinationPortOp = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.siteOP.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "siteOP" }, slot: "siteOP" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.siteOP.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.siteOP.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            attrs: {
                              disabled: _vm.readonly,
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "siteOp"
                              },
                              "default-value": _vm.job.siteOP || "",
                              "static-options": _vm.userPortRoleData.siteOp
                            },
                            on: {
                              change: function(p) {
                                _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.overseaOp.slaveVisible,
                          expression: "elementDict.overseaOp.slaveVisible"
                        }
                      ],
                      attrs: { slot: "overseaOp" },
                      slot: "overseaOp"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.overseaOp.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.overseaOp.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "overseaOp",
                        staticClass: "input2",
                        attrs: {
                          no: "overseaOp",
                          disabled: _vm.readonly,
                          "default-value": _vm.job.overseaOp || "",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "static-options": _vm.isHC
                            ? null
                            : _vm.userPortRoleData.overseaOp ||
                              _vm.overseaAgentUsersList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.job.overseaOp = p.value
                            _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                              _vm.view,
                              p
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.userDefinedRoleId1.slaveVisible &&
                            _vm.isAddUserDefinedRoles,
                          expression:
                            "elementDict.userDefinedRoleId1.slaveVisible && isAddUserDefinedRoles"
                        }
                      ],
                      attrs: { slot: "userDefinedRoleId1" },
                      slot: "userDefinedRoleId1"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId1.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId1.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          disabled: _vm.readonly,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole1
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.userDefinedRoleId2.slaveVisible &&
                            _vm.isAddUserDefinedRoles,
                          expression:
                            "elementDict.userDefinedRoleId2.slaveVisible && isAddUserDefinedRoles"
                        }
                      ],
                      attrs: { slot: "userDefinedRoleId2" },
                      slot: "userDefinedRoleId2"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId2.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          disabled: _vm.readonly,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole2
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.userDefinedRoleId3 &&
                  _vm.elementDict.userDefinedRoleId3.slaveVisible &&
                  _vm.isAddUserDefinedRoles
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedRoleId3" },
                          slot: "userDefinedRoleId3"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedRoleId3.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedRoleId3.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId3",
                            attrs: {
                              no: "userDefinedRoleId3",
                              disabled: _vm.readonly,
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole3"
                              },
                              "default-value": _vm.job.userDefinedRoleId3 || "",
                              "merge-load": true,
                              "static-options":
                                _vm.userPortRoleData.userDefinedRole3
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.userDefinedRoleId3Handler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedRoleId4 &&
                  _vm.elementDict.userDefinedRoleId4.slaveVisible &&
                  _vm.isAddUserDefinedRoles
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedRoleId4" },
                          slot: "userDefinedRoleId4"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedRoleId4.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedRoleId4.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId4",
                            attrs: {
                              no: "userDefinedRoleId4",
                              disabled: _vm.readonly,
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole4"
                              },
                              "default-value": _vm.job.userDefinedRoleId4 || "",
                              "merge-load": true,
                              "static-options":
                                _vm.userPortRoleData.userDefinedRole4
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.userDefinedRoleId4Handler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedRoleId5 &&
                  _vm.elementDict.userDefinedRoleId5.slaveVisible &&
                  _vm.isAddUserDefinedRoles
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedRoleId5" },
                          slot: "userDefinedRoleId5"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedRoleId5.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedRoleId5.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId5",
                            attrs: {
                              no: "userDefinedRoleId5",
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole5"
                              },
                              "default-value": _vm.job.userDefinedRoleId5 || "",
                              disabled: _vm.readonly,
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.userDefinedRoleId5Handler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedRoleId6 &&
                  _vm.elementDict.userDefinedRoleId6.slaveVisible &&
                  _vm.isAddUserDefinedRoles
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedRoleId6" },
                          slot: "userDefinedRoleId6"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedRoleId6.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedRoleId6.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId6",
                            attrs: {
                              no: "userDefinedRoleId6",
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole6"
                              },
                              "default-value": _vm.job.userDefinedRoleId6 || "",
                              disabled: _vm.readonly,
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.userDefinedRoleId6Handler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedRoleId7 &&
                  _vm.elementDict.userDefinedRoleId7.slaveVisible &&
                  _vm.isAddUserDefinedRoles
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedRoleId7" },
                          slot: "userDefinedRoleId7"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedRoleId7.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedRoleId7.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId7",
                            attrs: {
                              no: "userDefinedRoleId7",
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole7"
                              },
                              "default-value": _vm.job.userDefinedRoleId7 || "",
                              disabled: _vm.readonly,
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.userDefinedRoleId7Handler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedRoleId8 &&
                  _vm.elementDict.userDefinedRoleId8.viewable &&
                  _vm.isAddUserDefinedRoles
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedRoleId8" },
                          slot: "userDefinedRoleId8"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedRoleId8.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedRoleId8.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId8",
                            attrs: {
                              no: "userDefinedRoleId8",
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole8"
                              },
                              "default-multiple-value": _vm.toNumArray(
                                _vm.job.userDefinedRoleId8
                              ),
                              disabled: _vm.readonly,
                              multiple: true,
                              "merge-load": true,
                              placeholder: _vm.readonly ? " " : ""
                            },
                            on: {
                              change: function(p) {
                                _vm.job.userDefinedRoleId8 = _vm.toTxt(p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.satisfiedRequests.slaveVisible,
                          expression:
                            "elementDict.satisfiedRequests.slaveVisible"
                        }
                      ],
                      attrs: { slot: "satisfiedRequests" },
                      slot: "satisfiedRequests"
                    },
                    [
                      _c("special-requests-grid", {
                        ref: "selectedSpecialRequest",
                        attrs: {
                          no: "116",
                          "customer-id": Number(_vm.job.customerId),
                          lob: _vm.job.lob,
                          job: _vm.job,
                          "is-edit": _vm.isEdit
                        },
                        model: {
                          value: _vm.job.satisfiedRequests,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "satisfiedRequests", $$v)
                          },
                          expression: "job.satisfiedRequests"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.elementDict.userDefinedField1.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedField1" },
                          slot: "userDefinedField1"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedField1.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedField1.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "117",
                              disabled: _vm.readonly,
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField1"),
                                  _vm.job.userDefinedField1,
                                  function(val) {
                                    _vm.job.userDefinedField1 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.userDefinedField1,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "userDefinedField1", $$v)
                              },
                              expression: "job.userDefinedField1"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedField2.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedField2" },
                          slot: "userDefinedField2"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedField2.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedField2.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "118",
                              disabled: _vm.readonly,
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField2"),
                                  _vm.job.userDefinedField2,
                                  function(val) {
                                    _vm.job.userDefinedField2 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.userDefinedField2,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "userDefinedField2", $$v)
                              },
                              expression: "job.userDefinedField2"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedField3.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedField3" },
                          slot: "userDefinedField3"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedField3.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedField3.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "119",
                              disabled: _vm.readonly,
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField3"),
                                  _vm.job.userDefinedField3,
                                  function(val) {
                                    _vm.job.userDefinedField3 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.userDefinedField3,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "userDefinedField3", $$v)
                              },
                              expression: "job.userDefinedField3"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.userDefinedField4.slaveVisible
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "userDefinedField4" },
                          slot: "userDefinedField4"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.userDefinedField4.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.userDefinedField4.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "120",
                              disabled: _vm.readonly,
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField4"),
                                  _vm.job.userDefinedField4,
                                  function(val) {
                                    _vm.job.userDefinedField4 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.userDefinedField4,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "userDefinedField4", $$v)
                              },
                              expression: "job.userDefinedField4"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.taxNature &&
                  _vm.elementDict.taxNature.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "taxNature" }, slot: "taxNature" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.taxNature.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.taxNature.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "taxNature",
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                size: "mini"
                              },
                              model: {
                                value: _vm.job.taxNature,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "taxNature", $$v)
                                },
                                expression: "job.taxNature"
                              }
                            },
                            _vm._l(_vm.TAX_NATURES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.rateType &&
                  _vm.elementDict.rateType.slaveVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "rateType" }, slot: "rateType" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.rateType.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.rateType.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "rateType",
                                clearable: "",
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                size: "mini"
                              },
                              model: {
                                value: _vm.job.rateType,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "rateType", $$v)
                                },
                                expression: "job.rateType"
                              }
                            },
                            _vm._l(_vm.rateType, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm.showContactsInfoDialog
            ? _c("cargo-contacts-info-dialog", {
                attrs: {
                  visible: _vm.showContactsInfoDialog,
                  "customer-id": _vm.job.customerId,
                  "customer-contact": _vm.job.customerContact
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showContactsInfoDialog = $event
                  }
                }
              })
            : _vm._e(),
          _c("sop-dialog", {
            attrs: {
              visible: _vm.sopDialog.visible,
              "cmp-idx": _vm.sopDialog.cmpIdx,
              job: _vm.job,
              agent: _vm.sopDialog.agent,
              lob: "SI",
              "contact-list": _vm.sopDialog.contactList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.sopDialog, "visible", $event)
              },
              updateJob: function($event) {
                return _vm.$emit("updateJob")
              }
            }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              ref: "advanceTextDialog",
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                staticStyle: { height: "320px" },
                attrs: {
                  "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
                  "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                  "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
                  disabled: _vm.readonly
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.readonly,
                          expression: "!readonly"
                        }
                      ],
                      attrs: { no: "121", type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "122" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("import-prompt-title-dialog", {
            attrs: {
              visible: _vm.importPromptTitleDialog.visible,
              lob: _vm.job.lob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.importPromptTitleDialog, "visible", $event)
              },
              selected: function(p) {
                _vm.pm.onExcerptionChangeFunc(p)
              }
            }
          }),
          _c("import-bill-address-title-dialog", {
            attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billAddressDialog, "visible", $event)
              },
              callback: function(p) {
                _vm.pm.codeSearchCallback(p)
              }
            }
          }),
          _c("stamp-picture-view", {
            attrs: {
              visible: _vm.stampPictureView.visible,
              "business-documents": _vm.stampPictureView.businessDocuments
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.stampPictureView, "visible", $event)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }